import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-3 mt-auto">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center text-md-start mb-2 mb-md-0">
            <small>&copy; {new Date().getFullYear()} WallX Business Suite. All rights reserved.</small>
          </Col>
          <Col xs={12} md={6} className="text-center text-md-end">
            <small>Powered by <span className="fw-bold">WallX Africa</span></small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;